import type {SearchCriteriaRaw} from '../../../types';
import {createSavedSearchRule} from '../savedSearchRule';
import type {SavedSearchRule, TSearchTypeSavedSearch} from '../types';

export type RawSavedSearchSearchCriteria =
	SearchCriteriaRaw<TSearchTypeSavedSearch>;

export const rawSavedSearchCriteriaToRuleObject = (
	criteria: RawSavedSearchSearchCriteria,
): SavedSearchRule => {
	return createSavedSearchRule(parseInt(criteria.value1) || 0);
};

export default rawSavedSearchCriteriaToRuleObject;
